document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-product-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});
